import { alpha } from "@mui/material/styles";

import { brandColorTokens, brandRadius } from "@constants";

export const headerActionButtonStyle = {
  width: 44,
  height: 44,
  borderRadius: `${brandRadius.medium}px`,
  border: 1,
  borderColor: brandColorTokens.line.light,
  bgcolor: "transparent",
  color: brandColorTokens.text.bodyInverted,
  "&:hover": { bgcolor: alpha(brandColorTokens.text.bodyInverted, 0.1) },
};

export const headerBadgeStyle = {
  "& .MuiBadge-badge": { border: 2, borderColor: brandColorTokens.background.inverted, fontWeight: 500 },
};
